import gql from 'graphql-tag'

export const GET_USER_ME_QUERY = gql`
  query user_me {
    user_me @rest(type: "User", path: "/user-me") {
      id
      username
      email
    }
  }
`
